<template>
  <div class="payment-container">
    <h2>Payment Gateway Settings</h2>

    <!-- GK-PAY -->
    <div class="gateway-box">
      <h3>GK-PAY</h3>

      <div class="form-group">
        <label for="gkpayMerchantId">Merchant ID</label>
        <input type="text" id="gkpayMerchantId" v-model="datmanMerchantId" placeholder="Enter Merchant ID">
      </div>

      <div class="toggle-row">
        <span class="toggle-label">Activate GK-PAY</span>
        <div style="display:flex; align-items:center;">
          <label class="switch">
            <input type="checkbox" :checked="defaultPaymentGateway === 'Datman'" @change="setGateway('Datman', $event)">
            <span class="slider"></span>
          </label>
          <span class="status-text">{{ defaultPaymentGateway === 'Datman' ? 'ON' : 'OFF' }}</span>
        </div>
      </div>
    </div>

    <!-- Stripe -->
    <div class="gateway-box">
      <h3>Stripe</h3>

      <div class="form-group">
        <label for="stripePublishKey">Published Key</label>
        <input type="text" id="stripePublishKey" v-model="stripePublishKey" placeholder="Enter Published Key">
      </div>

      <div class="form-group">
        <label for="stripeSecretKey">Secret Key</label>
        <input type="text" id="stripeSecretKey" v-model="stripeSecretKey" placeholder="Enter Secret Key">
      </div>

      <div class="toggle-row">
        <span class="toggle-label">Activate Stripe</span>
        <div style="display:flex; align-items:center;">
          <label class="switch">
            <input type="checkbox" :checked="defaultPaymentGateway === 'Stripe'" @change="setGateway('Stripe', $event)">
            <span class="slider"></span>
          </label>
          <span class="status-text">{{ defaultPaymentGateway === 'Stripe' ? 'ON' : 'OFF' }}</span>
        </div>
      </div>
    </div>

    <div style="display:flex; align-items:center; gap:12px;">
      <button class="save-btn" @click="updateWebConfig">Save Payment Settings</button>
      <img v-if="showWebConfigLoading" src="/img/loading.gif" alt="loading" width="30" height="30">
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';

export default {
  props: [
    'webConfig',
    'requestHeader',
  ],
  data() {
    return {
      datmanMerchantId: '',
      stripeSecretKey: '',
      stripePublishKey: '',
      defaultPaymentGateway: '',
      showWebConfigLoading: false,
    }
  },
  mounted() {
    this.datmanMerchantId = this.webConfig.datmanMerchantId || '';
    this.stripeSecretKey = this.webConfig.stripeSecretKey || '';
    this.stripePublishKey = this.webConfig.stripePublishKey || '';
    this.defaultPaymentGateway = this.webConfig.defaultPaymentGateway || '';
  },
  methods: {
    ...mapMutations(['setRestaurantWebConfig']),

    setGateway(gateway, event) {
      this.defaultPaymentGateway = event.target.checked ? gateway : '';
    },

    updateWebConfig() {
      this.showWebConfigLoading = true;
      let dataToSubmit = { ...this.webConfig };
      dataToSubmit.datmanMerchantId = this.datmanMerchantId;
      dataToSubmit.stripeSecretKey = this.stripeSecretKey;
      dataToSubmit.stripePublishKey = this.stripePublishKey;
      dataToSubmit.defaultPaymentGateway = this.defaultPaymentGateway;

      let url = process.env.VUE_APP_API_URL + '/api/webConfig/update';

      axios
        .post(url, dataToSubmit, { headers: this.requestHeader })
        .then((data) => {
          if (data.status == 200) {
            this.showWebConfigLoading = false;
            this.$toastr.s("Successfully Updated.", "Success");
            this.setRestaurantWebConfig(data.data);
          }
        })
        .catch(() => {
          this.showWebConfigLoading = false;
        });
    },
  }
}
</script>

<style scoped>
  .payment-container {
    max-width: 50%;
    background: #fff;
    padding: 25px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }

  .payment-container h2 {
    margin-bottom: 20px;
    color: #222;
  }

  .gateway-box {
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    background: #fafafa;
  }

  .gateway-box h3 {
    margin-top: 0;
    margin-bottom: 15px;
    color: #ff5a00;
  }

  .form-group {
    margin-bottom: 15px;
  }

  .form-group label {
    display: block;
    font-weight: bold;
    margin-bottom: 6px;
  }

  .form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }

  .toggle-label {
    font-weight: bold;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 28px;
  }

  .switch input {
    display: none;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: #ccc;
    transition: .3s;
    border-radius: 30px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 22px;
    width: 22px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .3s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #28a745;
  }

  input:checked + .slider:before {
    transform: translateX(24px);
  }

  .save-btn {
    background: #ff5a00;
    color: white;
    border: none;
    padding: 12px 22px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 16px;
  }

  .save-btn:hover {
    background: #e14d00;
  }

  .status-text {
    font-size: 14px;
    margin-left: 10px;
    color: #555;
  }
</style>
